import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    divider: {
      display: 'block',
      width: '100%',
      marginBlock: '40px',
    },
    wrapTitle: {
      marginBottom: 40,
    },
    detailsContainer: {
      marginTop: 40,
    },
    iconFormat: {
      background: palette.deepBlue,
      color: palette.white,
      borderRadius: '50%',
      padding: 6,
      transform: 'scale(.7)',
    },
    iconActive: {
      color: palette.green,
      marginRight: 5,
      fontSize: 22,
    },
    iconCancel: {
      color: palette.red,
      marginRight: 5,
      fontSize: 22,
    },
  });
